/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import {
  useTheme,
  fade,
  makeStyles,
  withStyles,
} from '@material-ui/core/styles';

import Autocomplete from '@material-ui/lab/Autocomplete';
import Popper from '@material-ui/core/Popper';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import InputBase from '@material-ui/core/InputBase';
import ButtonBase from '@material-ui/core/ButtonBase';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';
import ListSubheader from '@material-ui/core/ListSubheader';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import LabelTwoToneIcon from '@material-ui/icons/LabelTwoTone';

import { logger } from './../../../utils/utils';

import { useLabelGetListAll } from './../../../hooks/useData';

import { backdropStyles } from './../../../styles/globalStyles/feedbackStyles';

const useStyles = makeStyles((theme) => ({
  ...backdropStyles(theme),
  root: {
    width: '100%',
    fontSize: 13,
    position: 'relative',
  },
  button: {
    fontSize: 13,
    width: '100%',
    textAlign: 'left',
    paddingBottom: 8,
    color: '#586069',
    fontWeight: 600,
    '&:hover,&:focus': {
      color: '#0366d6',
    },
    '& span': {
      width: '100%',
    },
    '& svg': {
      width: 16,
      height: 16,
    },
  },
  tag: {
    marginTop: 3,
    height: 20,
    padding: '.15em 4px',
    fontWeight: 600,
    lineHeight: '15px',
    borderRadius: 2,
  },
  popper: {
    border: '1px solid rgba(27,31,35,.15)',
    boxShadow: '0 3px 12px rgba(27,31,35,.15)',
    borderRadius: 3,
    width: 300,
    zIndex: theme.zIndex.drawer + 1,
    fontSize: 13,
    color: '#586069',
    backgroundColor: '#f6f8fa',
  },
  header: {
    borderBottom: '1px solid #e1e4e8',
    padding: '8px 10px',
    fontWeight: 600,
  },
  inputBase: {
    padding: 10,
    width: '100%',
    borderBottom: '1px solid #dfe2e5',
    '& input': {
      borderRadius: 4,
      backgroundColor: theme.palette.common.white,
      padding: 8,
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      border: '1px solid #ced4da',
      fontSize: 14,
      '&:focus': {
        boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  paper: {
    boxShadow: 'none',
    margin: 0,
    color: '#586069',
    fontSize: 13,
  },
  option: {
    minHeight: 'auto',
    alignItems: 'flex-start',
    padding: 8,
    '&[aria-selected="true"]': {
      backgroundColor: 'transparent',
    },
    '&[data-focus="true"]': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  popperDisablePortal: {
    position: 'relative',
  },
  iconSelected: {
    width: 17,
    height: 17,
    marginRight: 5,
    marginLeft: -2,
  },
  color: {
    width: 14,
    height: 14,
    flexShrink: 0,
    borderRadius: 3,
    marginRight: 8,
    marginTop: 2,
  },
  text: {
    flexGrow: 1,
  },
  close: {
    opacity: 0.6,
    width: 18,
    height: 18,
  },
  chipContainner: {
    display: 'flex',
    flexWrap: 'wrap',
    // justifyContent: 'center',
    // '& > *': {
    //   margin: theme.spacing(0.5),
    // },
  },
}));

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const ChipLabels = React.memo(({ labels }) => {
  const theme = useTheme();
  return labels.map((label, index) => {
    let styles = label.style ? JSON.parse(label.style) : null;
    let style = styles
      ? {
          backgroundColor: styles.backgroundColor,
          color: theme.palette.getContrastText(styles.backgroundColor),
          marginTop: 2,
          marginBottom: 2,
          marginRight: 4,
        }
      : {};
    let names = label.name ? label.name.split('/') : [];
    return (
      label.name && (<React.Fragment key={index}>
        <HtmlTooltip title={label.name}>
          <Chip
            label={
              // <Typography style={{ whiteSpace: 'normal', fontSize: '0.9em' }}>
              //   {label.name}
              // </Typography>
              <div>
                <Box display="flex" flexWrap="wrap">
                  {/* {names.map((name, index) => (
                    <React.Fragment key={index}>
                      <Box
                        css={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: 90,
                          fontSize: '0.9em',
                        }}
                      >
                        {name}
                      </Box>
                      {index != names.length - 1 && <Box>/</Box>}
                    </React.Fragment>
                  ))} */}
                  {names
                    .map((name, index) => (
                      <Box
                        css={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: 90,
                          fontSize: '0.9em',
                        }}
                        // key={`box-${index}`}
                      >
                        {name}
                      </Box>
                    ))
                    .reduce((prev, curr, index) => [
                      prev,
                      <Box key={`concat-box-${index}`}>/</Box>,
                      curr,
                    ])}
                </Box>
              </div>
            }
            size="small"
            style={style}
          />
        </HtmlTooltip>
        </React.Fragment>
      )
    );
  });
});

/**
 * LabelPicker() (Component)
 * @returns Label Picker
 * Available on: https://material-ui.com/components/autocomplete/ (GitHub's picker)
 */
const LabelPicker = React.memo(({ value, onChange, onBlur }) => {
  const classes = useStyles();
  const theme = useTheme();

  logger('LabelPicker render');

  const [anchorEl, setAnchorEl] = useState(null);

  // //Original state value but conflict with value props then change state name to selectedValue
  const [selectedValue, setSelectedValue] = useState(value || []);
  const [pendingValue, setPendingValue] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const labels = useLabelGetListAll();

  useEffect(() => {
    if (value) setSelectedValue(value);
  }, [value]);

  const handleClick = (event) => {
    setPendingValue(selectedValue);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async (event, reason) => {
    if (reason === 'toggleInput') {
      return;
    }
    !isLoading && setIsLoading(true);

    if (anchorEl) {
      anchorEl.focus();
    }
    setAnchorEl(null);

    // Custom component by add onBlur event
    if (onBlur) {
      await onBlur(pendingValue, selectedValue, () => {
        setSelectedValue(pendingValue);
      });
    } else {
      if (JSON.stringify(pendingValue) !== JSON.stringify(selectedValue))
        setSelectedValue(pendingValue);
    }
    
    setIsLoading(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'github-label' : undefined;

  /**
   * options extend group prop from labels
   * NOTE: Custom group (Extend from GitHub's picker)
   */
  let options = labels.map((option) => {
    const groups = option.name.split('/');
    const grouping = groups.length > 1 ? groups[0] : '';
    return {
      grouping,
      ...option,
    };
  });

  /**
   * renderGroup() (Component)
   * @param {*} params
   * @returns
   * NOTE: Custom group (Extend from GitHub's picker)
   */
  const renderGroup = (params) => {
    return [
      <ListSubheader
        key={params.key}
        component="div"
        style={{ fontWeight: 'bold', backgroundColor: '#FFF', top: -10 }}
      >
        {params.key > 0 && <Divider />}
        {params.group && <Box ml={1}>{params.group}</Box>}
        {!params.group && <Box mt={1}></Box>}
      </ListSubheader>,
      params.children.map((item, index) => (
        <Box ml={params.group ? 2 : 0} key={index}>{item}</Box>
      )),
    ];
  };

  return (
    <React.Fragment>
      <div className={classes.root}>
        <ButtonBase
          disableRipple
          className={classes.button}
          aria-describedby={id}
          onClick={handleClick}
        >
          <span>เลือกป้ายกำกับ</span>
          <LabelTwoToneIcon />
        </ButtonBase>
        <div className={classes.chipContainner}>
          <ChipLabels labels={selectedValue} />
        </div>
        <Backdrop className={classes.innerBackdropStyle} open={isLoading}>
          <CircularProgress className={classes.circularProgressLoadStyle} />
        </Backdrop>
      </div>
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        className={classes.popper}
      >
        <div className={classes.header}>ค้นหา-เลือกติดป้ายกำกับ</div>
        <Autocomplete
          open
          onClose={handleClose}
          multiple
          classes={{
            paper: classes.paper,
            option: classes.option,
            popperDisablePortal: classes.popperDisablePortal,
          }}
          value={pendingValue}
          onChange={(event, newValue) => {
            onChange && onChange(newValue);
            setPendingValue(newValue);
          }}
          disableCloseOnSelect
          disablePortal
          renderTags={() => null}
          disableListWrap
          noOptionsText="ไม่พบป้ายกำกับ"
          renderGroup={renderGroup}
          renderOption={(option, { selected }) => {
            return (
              <React.Fragment>
                <DoneIcon
                  className={classes.iconSelected}
                  style={{ visibility: selected ? 'visible' : 'hidden' }}
                />
                <span
                  className={classes.color}
                  style={option.style ? JSON.parse(option.style) : ''}
                />
                <div className={classes.text}>
                  {option.name.split('/').length > 1
                    ? option.name.split('/')[1]
                    : option.name}
                </div>
                <CloseIcon
                  className={classes.close}
                  style={{ visibility: selected ? 'visible' : 'hidden' }}
                />
              </React.Fragment>
            );
          }}
          options={[...options].sort((a, b) => {
            // Display the selected labels first.
            let ai = selectedValue.indexOf(a);
            ai = ai === -1 ? selectedValue.length + options.indexOf(a) : ai;
            let bi = selectedValue.indexOf(b);
            bi = bi === -1 ? selectedValue.length + options.indexOf(b) : bi;
            return ai - bi;
          })}
          groupBy={(option) => option.grouping}
          getOptionLabel={(option) => option.name}
          getOptionSelected={(option, value) => option.name === value.name}
          renderInput={(params) => (
            <InputBase
              ref={params.InputProps.ref}
              inputProps={params.inputProps}
              autoFocus
              className={classes.inputBase}
            />
          )}
          // custom Group
        />
      </Popper>
    </React.Fragment>
  );
});

export { ChipLabels, LabelPicker };
